<template>
  <div class="bespread-wrap module-gameBenefits">
    <div class="screen-container">
      <div class="kv-content">
        <img src="../../assets/img/gameBenefits/bi.png" alt="" srcset="" class="bi" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.module-gameBenefits {
  // pointer-events: none;
  background-image: url("../../assets/img/gameBenefits/bg.png ");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .screen-container {
    width: 100%;
    .kv-content {
    //   position: absolute;
    //   bottom: 10vw;
    //   left: 50%;

    //   transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
        height: 100%;
    //   z-index: 1;
    //   gap: 2.5vw;
      .bi {
        width: auto;
        height: 850px;
      }
    //   .kv-btn {
    //       display: flex;
    //   align-items: center;
    //     justify-content: center;
    //     gap: 2vw;
    //     .ly-icon {
    //       width: 160px;
    //       height: auto;
    //     }
    //   }
    }
  }
}
@media screen and (max-width: 1200px) {
 
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
 
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/gameBenefits.vue